import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { addPvNew, isBaiduMap, isIPhone } from '../../../utils';
import { openUrlByOpenApi } from '@baidu/map-fe-utils';
import { mapGetters } from 'vuex';
export default {
  components: {},
  props: {
    skuData: {
      type: Object,
      default: () => {}
    },
    unique_id: {
      type: String,
      default: ''
    },
    // 列表主题
    theme: {
      type: String,
      default: () => {
        return '';
      }
    }
  },
  data() {
    return {
      isBaiduMap: isBaiduMap(),
      isIPhone: isIPhone()
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['is_dark'])), {}, {
    themeClass() {
      switch (this.theme) {
        case 'dark':
          // 黑色主题
          return 'dark-theme-list';
      }
      // 默认白色主题
      return '';
    },
    realPrice() {
      if (this.skuData.baidu_discount_price) {
        return this.skuData.baidu_discount_price / 100;
      }
      return this.skuData.sale_price / 100;
    },
    skuDiscount() {
      if (this.skuData.baidu_discount) {
        return this.skuData.baidu_discount / 100;
      }
      return this.skuData.discount_rate / 100;
    },
    specPrefix() {
      const {
        baidu_discount_price = 0,
        seckil_info = {}
      } = this.skuData || {};
      const {
        baidu_discount_price: skill_baidu_discount_price = 0,
        now_time = 0,
        seckill_begin_time = 0,
        seckill_end_time = 0
      } = seckil_info || {};
      // 判断是否在秒杀区间
      if (now_time && seckill_begin_time && seckill_end_time && now_time >= seckill_begin_time && now_time <= seckill_end_time) {
        // 是否存在秒杀百度折扣价;
        if (skill_baidu_discount_price) {
          return true;
        }
        return false;
      }
      // 是否存在百度折扣价
      if (baidu_discount_price) {
        return true;
      }
      return false;
    },
    foodCouponBg() {
      return this.is_dark ? 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/foodCoupon-bgdark.png' : 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/foodCoupon-bg.png';
    },
    skuType() {
      const validTypes = ['car_4s', 'car_newenergy', 'house_old', 'house_xinfang'];
      return validTypes.includes(this.skuData.sku_type);
    },
    isHouse() {
      return this.skuData.sku_type === 'house_old' || this.skuData.sku_type === 'house_xinfang';
    },
    isCar() {
      return this.skuData.sku_type === 'car_4s' || this.skuData.sku_type === 'car_newenergy';
    }
  }),
  mounted() {
    // 展现埋点
    this.buryHandle('show');
  },
  methods: {
    /**
     * 跳转购买商品详情页
     *
     * @returns {void}
     */
    goPurchase() {
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      this.buryHandle('click', 'more');
      const url = this.skuData.action_url || '';
      openUrlByOpenApi(url);
    },
    /**
     * 跳转详情页，查看更多优惠
     *
     * @returns {void}
     */
    purchaseMore() {
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      if (this.skuData.sku_type === 'cater' && this.skuData.poi_uid) {
        this.buryHandle('click', 'more');
        window.location.href = 'baidumap://map/place/detail?uid=' + this.skuData.poi_uid + '&popRoot=no&poi_ext_param={"anchor":{"type":"card","name":"meishivoucher","cardParams":{"source":"sybjdetail"}}}';
      } else {
        this.goPurchase();
      }
    },
    buryHandle(type, status) {
      let action = ['MCEDse.NewMedia.detailspage.sku'].concat(status ? [status] : []).concat(type ? [type] : []);
      addPvNew(action, {
        std_tag: this.skuData.std_tag,
        poi_uid: this.skuData.poi_uid,
        feed_id: this.unique_id,
        tp: this.skuData.tpSource,
        skutype: this.skuData.sku_type
      });
    },
    goBtnPurchase() {
      this.buryHandle('click');
      const url = this.skuData.button_url || this.skuData.action_url;
      openUrlByOpenApi(url);
    }
  }
};